/* eslint-disable react/destructuring-assignment */
/* eslint-disable semi */
import React from 'react'
import * as H from 'history'
import { Alert } from 'react-bootstrap'
import { ApplicationController } from '../../../controllers/ApplicationController'
import { ApplicationModel } from '../../../models/ApplicationModel'
import {
  Checkbox, MultiLineField, BooleanRadioButtonField, yesNoDataSource, AnzicField, validateFields, Label, TabHeading,
} from '../../../shared/fields'
import GoodsContainer from './Components/Goods'
import EventsContainer from './Components/Events'
import IPContainer from './Components/IP'
import OtherServicesContainer from './Components/OtherServices'
import SoftwareContainer from './Components/Software'
import TourismServicesContainer from './Components/TourismServices'
import { NextBackButtons } from '../../applicationForm-1/controls/NextBackButtons'
import { Backdrop } from '../../../shared/Backdrop'
import { getInvalidFileBlobIds, fillExportMarketFinancialsWithDefaults } from '../../../shared/Utility'
import tierActiveValidator from '../../../shared/tierActiveValidator'
import { DashboardFetch } from '../../../controllers/DashboardFetch';
import { HomeFetch } from '../../../controllers/HomeFetch';
import { GRANT_GUIDELINES_URL } from '..'

export interface EligibleProductsPageProps {
    model: ApplicationModel
    onChange: { (changes: Partial<ApplicationModel>, callback?: { (): any }): any }
    history: H.History
    preview?: boolean
}

export interface EligibleProductsPageState {
  exportingCheckboxError: boolean
  loading: boolean
  tierErrorMessage: string
  tierSelectionIsValid: boolean // includes RepBody;
}

export class EligibleProductsPage extends React.Component<EligibleProductsPageProps, EligibleProductsPageState> {
  exportingGoods: Checkbox
  exportingTourism: Checkbox
  exportingOtherServices: Checkbox
  exportingEvents: Checkbox
  exportingIPOrKnowHow: Checkbox
  exportingSoftware: Checkbox
  exportDescription: MultiLineField
  haveExportPlan: BooleanRadioButtonField
  ajax: ApplicationController
  anzicTest: AnzicField
  softwareContainer: SoftwareContainer
  goodsContainer: GoodsContainer
  tourismServicesContainer: TourismServicesContainer
  otherServicesContainer: OtherServicesContainer
  eventsContainer: EventsContainer
  iPContainer: IPContainer
  hiddenExportingCheckbox: Checkbox

  dashboardFetch = new DashboardFetch();
  homeFetch = new HomeFetch();
  constructor(props: EligibleProductsPageProps) {
    super(props)

    this.state = {
      loading: false,
      exportingCheckboxError: false,
      tierSelectionIsValid: true, // if you get to this Tab4, it must be true (until you re-validate it)
      tierErrorMessage: '',
    }

    this.ajax = new ApplicationController()
  }

  handleGoodsCheckbox = (exportingGoods: boolean) => {
    const { onChange } = this.props

    this.setState({ exportingCheckboxError: false }, () => {
      onChange({
        exportingGoods: exportingGoods || null,
        areGoodsMadeInAustralia: null,
        goodsSatisfyNonAustralianCriteria: null,
        doAustralianGoodsMeetRequirement: null,
        areGoodsInappropriate: null,
        commodityCodes: [],
      })
    })
  }

  handleTourismServicesCheckbox = (exportingTourism: boolean) => {
    const { onChange } = this.props

    this.setState({ exportingCheckboxError: false }, () => {
      onChange({
        exportingTourism: exportingTourism || null,
        areTourismServicesSuppliedToForeignPersons: null,
        tourismExcludedServices: null,
        tourismServiceSatisfyRequirement: null,
      })
    })
  }

  handleOtherServicesCheckbox = (exportingOtherServices: boolean) => {
    const { onChange } = this.props

    this.setState({ exportingCheckboxError: false }, () => {
      onChange({
        exportingOtherServices: exportingOtherServices || null,
        areOtherServicesSuppliedToForeignPersons: null,
        servicesEligibilityCriteria: null,
        servicesExcluded: null,
      })
    })
  }

  handleSoftwareCheckbox = (exportingSoftware: boolean) => {
    const { onChange } = this.props

    this.setState({ exportingCheckboxError: false }, () => {
      onChange({
        exportingSoftware: exportingSoftware || null,
        isSoftwareCopyright: null,
        describeResearchInAustraliaSoftware: null,
        softwareRelatesToAustralianResearch: null,
      })
    })
  }

  handleIPCheckbox = (exportingIPOrKnowHow: boolean) => {
    const { onChange } = this.props

    this.setState({ exportingCheckboxError: false }, () => {
      onChange({
        exportingIPOrKnowHow: exportingIPOrKnowHow || null,
        isTrademarked: null,
        isUsedInAustralia: null,
        describeUseInAustralia: null,
        describeResearchInAustraliaIpKnowHow: null,
      })
    })
  }

  handleEventsCheckbox = (exportingEvents: boolean) => {
    const { onChange } = this.props

    this.setState({ exportingCheckboxError: false }, () => {
      onChange({
        exportingEvents: exportingEvents || null,
        isEventHeldInAustralia: null,
        isEventHeldOnline: null,
        eventNotHeldAnywhere: null,
      })
    })
  }

  next = () => {
    const { model } = this.props
    const { loading } = this.state
    if (loading) {
      return
    }

      this.setState({
          exportingCheckboxError: !model.exportingGoods
              && !model.exportingTourism
              && !model.exportingOtherServices
              && !model.exportingEvents
              && !model.exportingIPOrKnowHow
              && !model.exportingSoftware }, () => {
      validateFields((res) => {
        if (res) {
          const { model, history, onChange } = this.props
          let exportMarketFinancials = [...model.exportMarketFinancials]
          if (exportMarketFinancials && exportMarketFinancials.length > 0) {
            exportMarketFinancials = fillExportMarketFinancialsWithDefaults(exportMarketFinancials)
          }
          const invalidDocuments = getInvalidFileBlobIds(model)
          const updatedModel = { ...JSON.parse(JSON.stringify(model)), invalidDocuments, exportMarketFinancials }
          this.ajax.updateApplication(
            this,
            updatedModel,
            async (d) => {
              onChange({ ...model, ...d })
              // history.push(`/reform/${model.applicationID}/finalise`)
              // run tier validations on saveNext btn: user-story #143098
              // Reset the validation state, prior to re-running validation logic
              this.setState({ tierSelectionIsValid: false }, async () => {
                await this.validateTierOnSaveNext();

                // Only navigate to next page if validation passes
                if (this.state.tierSelectionIsValid) {
                  history.push(`/reform/${model.applicationID}/finalise`)
                }
              });
            },
          )
        }
      },
      this.hiddenExportingCheckbox,
      this.exportDescription,
      this.haveExportPlan,
      this.goodsContainer,
      this.tourismServicesContainer,
      this.otherServicesContainer,
      this.eventsContainer,
      this.iPContainer,
      this.softwareContainer,
      )
    })
  }

  validateTierOnSaveNext = async (): Promise<void> => {
    const { model } = this.props
    const selectedTierValue = model.isPeakIndustryBody ? '0' : model.applicationTier; // for RepBody, LHS = 0;

    await tierActiveValidator({
      selectedTierValue,
      dashboardFetch: this.dashboardFetch,
      setState: this.setState.bind(this),
    });
  };

  toggleSpinner(on: boolean, callback: { (): any }): void {
    this.setState({ loading: on }, callback)
  }

  render() {
    const {
      onChange, model, preview, history,
    } = this.props

    const { loading, exportingCheckboxError } = this.state
    const isExporOptionsRequired = !model.exportingGoods
                                    && !model.exportingTourism
                                    && !model.exportingOtherServices
                                    && !model.exportingEvents
                                    && !model.exportingIPOrKnowHow
                                    && !model.exportingSoftware

    return (
      <>
        <TabHeading
          label="Eligible products"
          preview={preview}
        />
        <Label
          label={model.isPeakIndustryBody
            ? `68. Are you or SME members of your Representative body seeking to export or promote to overseas buyers one or more of the following eligible products? *`
            : `68. Are you seeking to export or promote to overseas buyers one or more of the following eligible products? *`}
          preview={preview}
        />
        <i>
            Refer to section 5.2 of the
            {' '}
            <a target="_blank" href={`${GRANT_GUIDELINES_URL}`} rel="noreferrer">
                Grant Guidelines
            </a>
            {' '}
            for guidance on eligible products.
        </i>
        <Alert className="emdg-page-alerts">
            You may select multiple categories of eligible products. You must respond to questions specific for the selected eligible products.
            Eligible products must satisfy the conditions prescribed in the EMDG Rules
        </Alert>

        {/* checkbox for validation and focus when no selection is made for exports */ }
        <Checkbox
          ref={(r) => { this.hiddenExportingCheckbox = r }}
          id="hiddenExportingCheckbox"
          required={isExporOptionsRequired}
          onChange={() => {}}
          value={false}
          label=""
          className="hidden-checkbox"
        />

        <Checkbox
          ref={(r) => { this.exportingGoods = r }}
          id="goods"
          onChange={(exportingGoods) => this.handleGoodsCheckbox(exportingGoods)}
          value={model.exportingGoods}
          label={<span>Goods</span>}
          className={exportingCheckboxError && isExporOptionsRequired ? 'checkbox-required' : ''}
          preview={preview}
          validateError={exportingCheckboxError}
        />

        <Checkbox
          ref={(r) => { this.exportingTourism = r }}
          id="tourismServices"
          onChange={(exportingTourism) => this.handleTourismServicesCheckbox(exportingTourism)}
          value={model.exportingTourism}
          label={<span>Tourism services</span>}
          className={exportingCheckboxError && isExporOptionsRequired ? 'checkbox-required' : ''}
          preview={preview}
          validateError={exportingCheckboxError}
        />

        <Checkbox
          ref={(r) => { this.exportingOtherServices = r }}
          id="otherServices"
          required={false}
          onChange={(exportingOtherServices) => this.handleOtherServicesCheckbox(exportingOtherServices)}
          value={model.exportingOtherServices}
          label={<span>Services other than tourism</span>}
          className={exportingCheckboxError && isExporOptionsRequired ? 'checkbox-required' : ''}
          preview={preview}
          validateError={exportingCheckboxError}
        />

        <Checkbox
          ref={(r) => { this.exportingEvents = r }}
          id="events"
          required={false}
          onChange={(exportingEvents) => this.handleEventsCheckbox(exportingEvents)}
          value={model.exportingEvents}
          label={<span>Events</span>}
          className={exportingCheckboxError && isExporOptionsRequired ? 'checkbox-required' : ''}
          preview={preview}
          validateError={exportingCheckboxError}
        />

        <Checkbox
          ref={(r) => { this.exportingIPOrKnowHow = r }}
          id="intellectualProperty"
          required={false}
          onChange={(exportingIPOrKnowHow) => this.handleIPCheckbox(exportingIPOrKnowHow)}
          value={model.exportingIPOrKnowHow}
          label={<span>Intellectual property/know-how</span>}
          className={exportingCheckboxError && isExporOptionsRequired ? 'checkbox-required' : ''}
          preview={preview}
          validateError={exportingCheckboxError}
        />

        <Checkbox
          ref={(r) => { this.exportingSoftware = r }}
          id="software"
          required={false}
          onChange={(exportingSoftware) => this.handleSoftwareCheckbox(exportingSoftware)}
          value={model.exportingSoftware}
          label={<span>Software</span>}
          className={exportingCheckboxError && isExporOptionsRequired ? 'checkbox-required' : ''}
          preview={preview}
          validateError={exportingCheckboxError}
        />
        {exportingCheckboxError ? (<div className="form-error">This field is required</div>) : null}
        <MultiLineField
          ref={(r) => { this.exportDescription = r }}
          id="exportDescription"
          label={model.isPeakIndustryBody
            ? '69. Provide a comprehensive description of the eligible products you intend to market in a foreign country. If you are applying as a Representative body, provide a comprehensive description of the eligible products you intend to market in a foreign country on behalf of your SME members'
            : '69. Provide a comprehensive description of the eligible products you intend to market in a foreign country.'}
          value={model.exportDescription}
          onChange={(exportDescription) => onChange({ exportDescription })}
          required
          maxLength={3000}
          preview={preview}
        />

        <GoodsContainer
          model={model}
          onChange={onChange}
          visible={model.exportingGoods}
          ref={(r) => { this.goodsContainer = r }}
          preview={preview}
        />
        <TourismServicesContainer
          model={model}
          onChange={onChange}
          visible={model.exportingTourism}
          ref={(r) => { this.tourismServicesContainer = r }}
          preview={preview}
        />
        <OtherServicesContainer
          model={model}
          onChange={onChange}
          visible={model.exportingOtherServices}
          ref={(r) => { this.otherServicesContainer = r }}
          preview={preview}
        />
        <EventsContainer
          model={model}
          onChange={onChange}
          visible={model.exportingEvents}
          ref={(r) => { this.eventsContainer = r }}
          preview={preview}
        />
        <IPContainer
          model={model}
          onChange={onChange}
          visible={model.exportingIPOrKnowHow}
          ref={(r) => { this.iPContainer = r }}
          preview={preview}
        />

        <SoftwareContainer
          model={model}
          onChange={onChange}
          visible={model.exportingSoftware}
          ref={(r) => { this.softwareContainer = r }}
          preview={preview}
        />

        <NextBackButtons
          onBack={() => history.push(`/reform/${model.applicationID}/expenses`)}
          onNext={this.next}
          preview={preview}
        />

        {/* tierValidation on SaveNext; user-story #143098 */}
        {this.state.tierErrorMessage
            && (
            <Alert className="emdg-page-alerts emdg-page-alerts--error">
              <div dangerouslySetInnerHTML={{ __html: this.state.tierErrorMessage }} />
            </Alert>
            )}

        <Backdrop on={loading} />
      </>
    )
  }
}
